import * as React from "react";

import TranslationService, { LocaleStrings } from "../services/translations/TranslationService";

const TranslationContext = React.createContext({
    translations: TranslationService.getTranslations() as LocaleStrings
})

export default TranslationContext;